var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-default',[_c('div',{staticClass:"box"},[_c('Chart',{attrs:{"type":"radar","data":_vm.chartData,"options":_vm.chartOptions}}),(!_vm.paidFor)?_c('div',[_vm._v("NAO PAGOU AINDA")]):_vm._e(),_c('div',{ref:"paypal"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }